export default __webpack_public_path__ + "static/media/cashRegister.80dcede6.svg";